import * as Linking from "expo-linking";
import { Platform } from "react-native";
import { APP_URL } from "~/lib/constants";

export function getAppUrl(path = "") {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  if (Platform.OS === "web") {
    const origin =
      typeof window !== "undefined" && window.location.origin
        ? window.location.origin
        : APP_URL;
    return `${origin.replace(/\/+$/, "")}${normalizedPath}`;
  }
  return Linking.createURL(normalizedPath.replace(/^\//, ""));
}
